<template>
  <v-container>
    <v-row>
      <v-col class="d-flex align-start mb-6">
        <span class="text-left">
          {{ `${numText}: ${questionText}` }}
        </span>
        <span v-if="required" class="red--text text--lighten-1">*</span>
      </v-col>
      <v-col>
        <v-container class="pa-0" fluid>
          <v-checkbox v-for="(option, i) in options" :key="i" v-model="response" :label="`${option}`" :value="i" color="#1791b1" class="pa-0 ma-0" @change="sortAndEmit" />
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'MultiSelector',
  props: {
    questionText: {
      type: String,
      required: true
    },
    numText: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      response: [],
      question: {}
    }
  },
  methods: {
    sortAndEmit: function () {
      const res = []
      this.response.forEach(element => res.push(element + 1))
      res.sort()
      this.$emit('update', `[${res.toString()}]`)
    }
  }
}
</script>
